import React from "react";
import { TicketRow } from "./../../../common/components/TicketRow";
import { TicketRowDetail } from "./TicketRowDetail";
import './TicketsTable.scss';
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTicketsBuilder } from "../../hooks/useTicketsBuilder";
import { usePickerContext } from "../../hooks/usePickerContext";
import { usePickerCore } from "../../hooks/usePickerCore";

export function TicketsTable({ isValidSteps }) {
    // console.log('TicketsTable')
    const { state, dispatch } = usePickerContext();
    const { deleteTicket, changeFormulaTicket, changePassTicket } = usePickerCore();
    const { dates, total } = useTicketsBuilder({
        sortByDate: true
    });

    const currentDate = state.dates.find(date => date.current);

    return (
        <section className={"PickerContainer-section TicketsTable-container"}>
            <header className="PickerContainer-sectionHeader">
                <span className={"PickerContainer-title h3 TicketsTable-title"}>{state.translations.PLC_MY_TICKETS} :</span>
            </header>
            <table className={"TicketsTable"}>
                <thead>
                <tr>
                    <th>{state.translations.PLC_TBL_BILLETS_CATEGORIE}</th>
                    <th>{state.translations.PLC_TBL_BILLETS_PLACE}</th>
                    <th>{state.translations.PLC_TBL_BILLETS_FORMULE}</th>
                    <th>{state.translations.PLC_TBL_BILLETS_PRIX}</th>
                </tr>
                </thead>
                {dates.map((date, index) => {
                    const isSelected = date.current;
                    let hasTicket = false
                    date.hours[0].tickets.forEach(ticket => {
                        if(hasTicket === false){
                            hasTicket = date.hours[0].at === ticket.hour.widget.startHour
                        } 
                    })
                    let rows;
                    if (isSelected && hasTicket) {
                        rows = date.hours[0].tickets.filter(ticket => {
                            return date.hours[0].at === ticket.hour.widget.startHour
                        }).map((ticket, index) => {
                            const category = ticket.category || date.hours[0].widget.categories.filter(category => category.id === ticket.categoryId)[0];
                            const ticketPricing = date.hours[0].widget.pricing.filter(p => p.categoryId === ticket.categoryId);
                            return (
                                <TicketRow
                                    {...ticket}
                                    key={index}
                                    category={category}
                                    pricing={ticketPricing}
                                    onDelete={() => deleteTicket(ticket)}
                                    onChangeFormula={formula => changeFormulaTicket(ticket, formula)}
                                    onInputPassCode={passCode => changePassTicket(ticket, passCode)}
                                />
                            )
                        })
                    } else if (isSelected) {
                        rows = (
                            <tr>
                                <td colSpan={6}>Aucune place sélectionnée.</td>
                            </tr>
                        )
                    }

                    return (
                        <tbody
                            key={index}
                            className={'TicketsTable-body' + (isSelected ? ' TicketsTable-bodySelected' : '')}
                        >
                        <tr>
                            <th
                                className={'TicketsTable-bodyHeader'}
                                colSpan={6}
                                onClick={() => {
                                    if (!isSelected) dispatch({ type: 'SET_CURRENT_DATE', payload: date })
                                }}
                            >
                                <span className={'TicketsTable-stateIcon'}>
                                    <FontAwesomeIcon className='icon' icon={faAngleDown}/>
                                </span>
                                <TicketRowDetail date={date} isSelected={isSelected}/>
                            </th>
                        </tr>
                        {rows}
                        </tbody>
                    );
                })}
                <thead>
                <tr>
                    <th colSpan={3}>Total <span className={'TicketsTable-info'}>(tenant compte des packs)</span> :</th>
                    <th colSpan={3}>
                        {isValidSteps
                            ? `${total / state.dates.length}€`
                            : '-'
                        }
                    </th>
                </tr>
                </thead>
            </table>
        </section>
    )
}